(ns portal.user-account-page.db.personal-information
  (:require [clojure.spec.alpha :as spec]
            [clojure.string :as str]
            [common.form.core :as form]
            [phrase.alpha :as p]
            [re-frame.core :as rf]))

(def entity-name "Personal Information")

(def ui-messages
  {:success "Successfully saved"
   :failure "Failed to save"})

(defn email? [email]
  (re-matches #".+\@.+\..+" email))

(spec/def ::name
  (spec/and string?
            (complement str/blank?)))

(spec/def ::email
  (spec/and (complement str/blank?)
            email?))

(spec/def ::value
  (spec/keys :req-un [::name ::email]))

(p/defphraser (complement str/blank?)
  [_ problem]
  {:message "The field should not be empty"
   :in (:in problem)
   :problem problem})

(p/defphraser string?
  [_ problem key]
  {:message "The field should be a string"
   :in (:in problem)
   :problem problem})

(p/defphraser email?
  [_ problem]
  {:message "Not a valid email address"
   :in (:in problem)
   :problem problem})

(def validate-form
  (rf/enrich
   (form/get-validate-form-fn :form.personal-information ::value)))

(def forward-events
  [{:events #{:resource.user/get-me-success}
    :dispatch-to [:form.personal-information/set-initial-value]}
   {:events #{:resource.user/patch-me-success}
    :dispatch-to [:form.personal-information/submit-success]}
   {:events #{:resource.user/patch-me-failure}
    :dispatch-to [:form.personal-information/submit-failure]}])

(form/register-form {:namespace :form.personal-information
                     :forward-events forward-events
                     :validate-form validate-form
                     :submit-event :form.personal-information/submit-form})

(rf/reg-event-fx :form.personal-information/init-form
  (fn [_ _]
    {:fx [[:dispatch [:form.personal-information/change-mode :read]]
          [:dispatch [:form.personal-information/init]]]}))

(rf/reg-event-db :form.personal-information/set-initial-value
  (fn [db [_ [_ user]]]
    (update-in db [:form.personal-information] assoc
               :value user
               :meta {:initial-user user})))

(rf/reg-event-fx :form.personal-information/submit-form
  (fn [_ [_ payload sso]]
    (let [fields (cond-> [:name :privacySettingsAccepted] (not sso) (conj :email))
          payload (select-keys payload fields)]
      {:fx [[:dispatch [:loader/open]]
            [:dispatch [:resource.user/patch-me payload]]]})))

(rf/reg-event-fx :form.personal-information/submit-success
  (fn [_ _]
    {:fx [[:dispatch [:form.personal-information/change-mode :read]]
          [:dispatch [:loader/close]]
          [:dispatch [:response-handler/handle-response
                      {:entity-name entity-name
                       :type :success
                       :message (:success ui-messages)}]]]}))

(rf/reg-event-fx :form.personal-information/submit-failure
  (fn [_ [event response]]
    {:fx [[:dispatch [:loader/close]]
          [:dispatch [:response-handler/handle-response
                      {:entity-name entity-name
                       :type :error
                       :event event
                       :response response
                       :message (:failure ui-messages)}]]]}))

(rf/reg-event-fx :form.personal-information/cancel-edit
  (fn [{:keys [db]}]
    (let [initial-user (get-in db [:form.personal-information :meta :initial-user])]
      {:db (assoc-in db [:form.personal-information :value] initial-user)
       :fx [[:dispatch [:form.personal-information/change-mode :read]]]})))

(rf/reg-event-db :form.personal-information/change-mode
  (fn [db [_ mode]]
    (assoc-in db [:form.personal-information :mode] mode)))

(rf/reg-sub :form.personal-information/mode
  (fn [db]
    (get-in db [:form.personal-information :mode])))

(def use-bind-control (partial form/use-bind-control :form.personal-information))
(def use-error-message (partial form/use-error-message :form.personal-information))
